/** 当前 Fast.Element.Plus 包版本，发布时必须与 package.json 保持一致。 */
export const version = "2.0.20";
